import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CalenderPage } from './calender';

import { ComponentsModule } from '../components.module';

@NgModule({
  declarations: [
    CalenderPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(CalenderPage),
  ],
  exports: [
    CalenderPage
  ]
})
export class CalenderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/calender/calender.module.ts